import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { PlayArrow } from "@mui/icons-material";
import { useClinicalRegisterContext } from "@/contexts/ClinicalRegisterContext";

interface TeleconsultoriaJoinCallButtonProps {
  /** Mantido por compatibilidade com os chamadores; a sala abre na ActionBar. */
  roomUrl: string;
  appointmentId?: string;
  patientName?: string;
  /**
   * Antes: abria /summary com a sala (lista de convites).
   * Hoje todos os pontos iniciam o atendimento do teleconsultor; mantido por compatibilidade.
   */
  openOnPatientRecords?: boolean;
  patientId?: string;
  /** Obrigatório para iniciar: sem ele o botão fica desabilitado. */
  appointment?: fhir5.Appointment;
}

/**
 * Inicia (ou continua) o atendimento próprio do teleconsultor.
 * Cria um Encounter com partOf = Encounter do host e abre /clinicalregister.
 * Mesmo fluxo na lista de convites, ScheduleQueueActions e ProfessionalActions.
 */
export function TeleconsultoriaJoinCallButton({
  appointment,
}: TeleconsultoriaJoinCallButtonProps) {
  const { verifyEncounter } = useClinicalRegisterContext();
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    if (!appointment || loading) return;
    setLoading(true);
    try {
      // verifyEncounter exibe os toasts (sem convite, origem não iniciada, erro).
      await verifyEncounter(appointment, false, { asTeleconsultor: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={!appointment || loading}
      onClick={(event) => {
        // Na agenda o botão fica dentro de linhas clicáveis.
        event.stopPropagation();
        handleStart();
      }}
      startIcon={
        loading ? <CircularProgress size={16} color="inherit" /> : <PlayArrow />
      }
      sx={{ textTransform: "none" }}
    >
      Iniciar teleconsultoria
    </Button>
  );
}
